@if (confirmationResult(); as confirmationResult) {
  <main class="ats-center" aria-live="polite">
    <img
      [src]="confirmationResult.mainImage"
      aria-hidden="true"
      alt="{{ 'l-illustration-alt' | translate }}"
    />
    <h1 class="po-mt-4 text">{{ confirmationResult.title | translate }}</h1>
    <p class="po-mt-2 text">{{ confirmationResult.subtitle | translate }}</p>
    <po-button
      class="po-mt-2"
      p-kind="primary"
      [p-label]="'l-home-page-name' | translate"
      (p-click)="goToHome()"
    ></po-button>
  </main>
}
<ats-lib-loader-global></ats-lib-loader-global>
